import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '../../../core/auth/services/local-storage.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../core/auth/services/config.service';
import {
  GenerateTokenRequest,
  GenerateTokenResponse,
} from '../../dashboard/components/appoinmnet-Booking/appoinment-const/appoinment-model';

@Injectable({
  providedIn: 'root',
})
export class JitsiServicesService {
  http = inject(HttpClient);
  hostUrl = inject(ConfigService).getAPIUrl();
  patientHostUrl = inject(ConfigService).getPatientAPIUrl();
  localStorageService = inject(LocalStorageService);

  constructor() {}

  generateJitsiToken(payload: GenerateTokenRequest) {
    return this.http.post<GenerateTokenResponse>(
      `${this.hostUrl}/api/auth/GenerateJwtToken`,
      payload,
    );
  }


}
